import React from "react";
import SortableTableHeaderButton from "../sortable-table-header-button/SortableTableHeaderButton";
import "./DataTable.css";

const DataTable = ({
  className = "",
  columns,
  rows,
  getRowKey,
  renderRow,
  getRowClassName,
  onRowClick,
  sortKey,
  sortDir,
  onSort,
  loading = false,
  loadingMessage = "Loading...",
  emptyMessage = "No data found.",
  stateCellStyle,
}) => {
  const mergedClassName = ["data-table", className].filter(Boolean).join(" ");
  const colSpan = columns.length;

  return (
    <table className={mergedClassName}>
      <thead>
        <tr>
          {columns.map((column) => (
            <th key={column.key} className={column.headerClassName}>
              {column.sortable ? (
                <SortableTableHeaderButton
                  sortKey={column.key}
                  activeSortKey={sortKey}
                  sortDir={sortDir}
                  onSort={onSort}
                >
                  {column.label}
                </SortableTableHeaderButton>
              ) : (
                column.label
              )}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan={colSpan} style={stateCellStyle}>
              <span className="d-inline-flex align-items-center justify-content-center gap-2">
                <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true" />
                <span>{loadingMessage}</span>
              </span>
            </td>
          </tr>
        ) : rows.length === 0 ? (
          <tr>
            <td colSpan={colSpan} style={stateCellStyle}>
              {emptyMessage}
            </td>
          </tr>
        ) : (
          rows.map((row, index) => (
            <tr
              key={getRowKey(row)}
              className={getRowClassName ? getRowClassName(row, index) : undefined}
              onClick={onRowClick ? () => onRowClick(row, index) : undefined}
              style={onRowClick ? { cursor: "pointer" } : undefined}
            >
              {renderRow(row)}
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default DataTable;
